var boostPFS = new BoostPFS();
boostPFS.init(); 
if (typeof boostPFSConfig != 'undefined' 
	&& typeof boostPFSConfig.general != 'undefined' 
	&& typeof boostPFSConfig.general.isInitFilter != 'undefined' 
	&& boostPFSConfig.general.isInitFilter === true) { 
    if(Utils.isSearchPage()){
      Globals.productAvailable =  false;
      Globals.variantAvailable = false;
      boostPFSAppConfig.settings.general.sortingAvailableFirst = false;
      boostPFSAppConfig.settings.general.productAndVariantAvailable = false;
    }
	boostPFS.initFilter(); 
} 
BoostPFS.jQ(window).on('load', function(){
	boostPFS.initSearchBox();
	boostPFS.initAnalytics();
});